import { render, staticRenderFns } from "./imageUpload.vue?vue&type=template&id=ed610d86&scoped=true"
import script from "./imageUpload.vue?vue&type=script&lang=js"
export * from "./imageUpload.vue?vue&type=script&lang=js"
import style0 from "./imageUpload.vue?vue&type=style&index=0&id=ed610d86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed610d86",
  null
  
)

export default component.exports